export default __webpack_public_path__ + "static/media/conheca-nos.07c8dcb8.png";